// src/index.ts
import DeviceRendererService from "./device";
import ReglRendererService from "./regl";
export {
  DeviceRendererService,
  ReglRendererService
};
